/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import { useAppConfig } from '~/providers/app';

import { useMediaQuery } from '~/hooks/useMediaQuery';

import { Container } from './styles';

import { Clock } from '../Clock';

export const Header: FC = () => {
  const { config } = useAppConfig();
  const isLowerThan1050px = useMediaQuery('(max-width: 1050px)');

  return (
    <Container>
      {isLowerThan1050px ? (
        <div id="resp-view">
          <div>
            <h1>mapa de chamados</h1>
            <Clock />
          </div>
          <img src={config.logo} alt="logo" />
        </div>
      ) : (
        <>
          <h1>mapa de chamados</h1>
          <Clock />
          <img src={config.logo} alt="logo" />
        </>
      )}
    </Container>
  );
};
